// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SPdN9lLz5J4WK9a4nZvs{padding:16px 24px 24px}.K6b54ebu2MwSFePryFSW{flex-direction:column;gap:12px;margin-top:-2px;margin-bottom:-3px;display:flex}.xF7nzt6T67MXg1hOezSj{margin-bottom:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `SPdN9lLz5J4WK9a4nZvs`,
	"titleWrap": `K6b54ebu2MwSFePryFSW`,
	"status": `xF7nzt6T67MXg1hOezSj`
};
export default ___CSS_LOADER_EXPORT___;
